import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import htmlParser from "html-react-parser";

import './LoanOfficerInfo.css';

const LoanOfficer = ({ loanOfficer }) => {

  const imgURL = process.env.REACT_APP_CDN_URL;

  // Safeguard the values before passing to htmlParser
  const safeParse = (value) => (value ? htmlParser(value) : ""); // Return an empty string if the value is null or undefined

  const formatPhoneNumber = (phoneNumber) => {
    const cleaned = phoneNumber.replace(/\D/g, ''); // Remove all non-digit characters
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/); // Match the desired format
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`; // Format as (XXX) XXX-XXXX
    }
    return phoneNumber; // Return original if it doesn't match
  };

  return (
    <div id="MloWrapper">
      <Container>
        <Row id="mloRow" className="LoSpecific">
          <Col>
            <Image src={loanOfficer?.profileImage || `${imgURL}defaultProfileImage.webp`} fluid className="LO-Image" />
          </Col>
          <Col lg={8} className="LoSpecific-Details">
            <h4 className="LoHeading">
              {safeParse(loanOfficer?.name)}
            </h4>
            <p className="MLODetails">
              {safeParse(loanOfficer?.nmls)} | {safeParse(loanOfficer?.designation)}
              <br />
              <a
  href={`tel:+1${loanOfficer?.workPhoneNumber?.replace(/\D/g, '')}`}
  style={{ color: "#00AAE4", textDecoration: "none" }} // Fixed color code
  target="_blank"
  rel="noopener noreferrer"
>
   D: {formatPhoneNumber(loanOfficer?.workPhoneNumber)} {/* Prepend D: to the formatted number */}
</a>
              <br />
              <a
                href={`mailto:${loanOfficer?.emailAddress}`}
                style={{ color: "00AAE4", textDecoration: "none" }} target="_blank" rel="noopener noreferrer"
              >
                {safeParse(loanOfficer?.emailAddress)}
              </a>
              <br />
              <a
                href={`https://${loanOfficer?.userWebsite}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "00AAE4", textDecoration: "none" }}
              >
                {safeParse(loanOfficer?.userWebsite)}
              </a>
              <br />
              {safeParse(loanOfficer?.streetAddress)}
              <br></br>
              {safeParse(loanOfficer?.city)} {safeParse(loanOfficer?.state)} {safeParse(loanOfficer?.zipCode)}
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="ReadyToLeap">
              <h4>{safeParse(loanOfficer?.textHeading)}</h4>
              <p>{safeParse(loanOfficer?.textParagraph1)}</p>
              <p>{safeParse(loanOfficer?.textParagraph2)}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoanOfficer;
